<template>
	<div class="contact">
		<HeaderBar></HeaderBar>
		<section>
			<div class="container">
				<!-- <b-dropdown text="公司动态" variant="outline-primary" class="mt-4 mb-4">
					<b-dropdown-item href="#">公司新闻</b-dropdown-item>
					<b-dropdown-item href="#">政策导向</b-dropdown-item>
				</b-dropdown> -->
				<div class="row detail mt-4">
					<div class="col-lg-12">
						<div class="title">
							联系我们
						</div>
					</div>
				</div>
				<div class="row contact">
					<div class="col-lg-4">
						<div class="contact-box">
							<div class="icon"><i class="fa fa-map-marker"></i></div>
							<div class="title">公司地址</div>
							<div class="content">
                福州市晋安区盛辉大厦1801室<br />
							</div>
						</div>
					</div>
					<div class="col-lg-4">
						<div class="contact-box">
							<div class="icon"><i class="fa fa-tty"></i></div>
							<div class="title">公司电话</div>
							<div class="content">
								0591-87520930
							</div>
						</div>
					</div>
					<div class="col-lg-4">
						<div class="contact-box">
							<div class="icon"><i class="fa fa-comments-o"></i></div>
							<div class="title">Email地址</div>
							<div class="content">
                jingbiao.xu@3goldcreation.com
							</div>
						</div>
					</div>
				</div>
<!--				<div class="us">-->
<!--					<h3 class="text-center mb-30">客户信息</h3>-->
<!--					<div class="row">-->
<!--						<div class="col-10">-->
<!--							<b-form-group-->
<!--								label-cols="3"-->
<!--								label="姓名"-->
<!--								label-for="name"-->
<!--								label-align-sm="right"-->
<!--							>-->
<!--								<b-form-input id="name" v-model="form.name" trim></b-form-input>-->
<!--							</b-form-group>-->
<!--						</div>-->
<!--						<div class="col-10">-->
<!--							<b-form-group-->
<!--								label-cols="3"-->
<!--								label="电话"-->
<!--								label-for="mobile"-->
<!--								label-align-sm="right"-->
<!--							>-->
<!--								<b-form-input-->
<!--									:maxLength="11"-->
<!--									id="mobile"-->
<!--									v-model="form.mobile"-->
<!--									trim-->
<!--								></b-form-input>-->
<!--							</b-form-group>-->
<!--						</div>-->
<!--						<div class="col-10">-->
<!--							<b-form-group-->
<!--								label-cols="3"-->
<!--								label="备注"-->
<!--								label-for="content"-->
<!--								label-align-sm="right"-->
<!--							>-->
<!--								<b-form-textarea-->
<!--									id="content"-->
<!--									v-model="form.content"-->
<!--									trim-->
<!--								></b-form-textarea>-->
<!--							</b-form-group>-->
<!--						</div>-->
<!--						<div class="col-12">-->
<!--							<div class="text-center">-->
<!--								<b-button variant="success" @click="save">提交</b-button>-->
<!--							</div>-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
			</div>
		</section>
		<FooterBar></FooterBar>
	</div>
</template>

<script>
import HeaderBar from '@/components/header-bar';
import FooterBar from '@/components/footer-bar';
import { baseUrl } from '../../config/config';
export default {
	name: 'contact',
	components: {
		HeaderBar,
		FooterBar,
	},
	data() {
		return {
			form: {
				name: '',
				mobile: '',
				content: '',
			},
		};
	},
	computed: {},
	mounted() {},
	methods: {
		//保存客户信息
		save() {
			this.form.debug = 'cross';
			this.$axios
				.post(baseUrl + '/api/syn/collection/save', this.form)
				.then((res) => {
					if (res.data.code === 1) {
						alert(res.data.msg);
					} else {
						alert(res.data.msg);
					}
				});
		},
	},
};
</script>
<style lang="scss">
.contact {
	.detail {
		.title {
			text-align: center;
			font-size: 1.8rem;
			margin-bottom: 4rem;
			margin-top: 6rem;
		}
	}
	.contact {
		margin-bottom: 10rem;
		.contact-box {
			box-shadow: 0px 12px 39px 0px rgba(8, 18, 109, 0.08);
			padding: 3.4rem 0;
			justify-content: center;
			text-align: center;
			height: 328px;
			margin-bottom: 3rem;
			transition: all 0.5s;
			.icon {
				font-size: 5rem;
				width: 100%;
				color: #007bff;
			}
			.title {
				font-size: 1.6rem;
				margin-bottom: 1rem;
			}
			.content {
				color: #848484;
				font-size: 0.9rem;
				line-height: 1.4rem;
			}
			&:hover {
				box-shadow: 0px 12px 39px 0px rgba(8, 18, 109, 0.18);
			}
		}
	}
	.us {
		width: 700px;
		margin: 0 auto;
		margin-bottom: 100px;
	}
}
</style>
